module.exports = __webpack_public_path__ + "static/media/lion.29dd58ea.svg";